import React, { Fragment, Suspense } from "react";
import { Button } from "semantic-ui-react";
import { useBool } from "../../../sg-hooks/useBool";
import { IAuditNote, TEditableAuditNote } from "../../interfaces/IAuditNote";
import { useTranslation } from "react-i18next";
import IFormType from "../../interfaces/IFormType";
import ErrorBoundary from "../ErrorBoundary";
import { useNotification } from "../../../sg-core/hooks/useToast";
import EditableAuditNoteModal from "./EditableAuditNoteModal";
import { useEditableNotes } from "../../data/notes/useEditableNotes";
import { useInitialNoteData } from "../../data/notes/useInitialNoteData";

interface AddAuditNoteActionProps {
    fieldKey: IAuditNote["key"];
    parentObjectTitle?: string;
    fieldTitle: IAuditNote["fieldTitle"];
    formType: IFormType["id"];
    observationFormReference?: string;

    onSubmitted: (note: TEditableAuditNote) => void;
    disabled?: boolean;
};

export const AddAuditNoteAction: React.FC<AddAuditNoteActionProps> = ({
    fieldKey,
    fieldTitle,
    parentObjectTitle,
    formType,
    onSubmitted,
    observationFormReference,
    disabled = false,
}) => {

    const { t } = useTranslation();
    const toast = useNotification();

    const { noteList, updateNote, addNote, removeNote } = useEditableNotes(fieldKey);

    const initialData = useInitialNoteData({ key: fieldKey, fieldTitle });

    const texts = {
        addNote: t("Lisää huomio"),
        failedToOpenForm: t("Lomakkeen avaus epäonnistui!")
    }

    const [modalOpen, openModal, closeModal] = useBool()

    const _onSave = (auditNote: TEditableAuditNote) => {
        console.info("AddAuditNoteAction", { auditNote })
        addNote(auditNote);
        closeModal();
        onSubmitted(auditNote);
    };

    const onModalError = (error: Error) => {
        console.log(error)
        toast.error(texts.failedToOpenForm);
        closeModal();
    }


    return (
        <Fragment>
            <Suspense fallback={<Button style={{ whiteSpace: "nowrap" }} type="button" icon="plus square" content={texts.addNote} size="tiny" loading />}>

                <Button
                    style={{ whiteSpace: "nowrap" }}
                    type="button"
                    onClick={!disabled ? openModal : undefined}
                    icon="plus square"
                    content={texts.addNote}
                    disabled={disabled}
                    size="tiny"
                />

                {modalOpen && (
                    <ErrorBoundary onError={onModalError} fallback={<Fragment />}>
                        <EditableAuditNoteModal
                            fieldTitle={fieldTitle}
                            parentObjectTitle={parentObjectTitle}
                            auditFormType={formType}
                            observationFormType={observationFormReference}
                            onSubmit={_onSave}
                            onCancel={closeModal}

                            initialData={initialData}
                        />
                    </ErrorBoundary >
                )}
            </Suspense>
        </Fragment >
    );
};


/*
     {modalOpen && (
                <ErrorBoundary onError={onModalError} fallback={<Fragment />}>
                    <CreateAuditNoteModal
                        fieldKey={fieldKey}
                        fieldTitle={fieldTitle}
                        formType={formType}
                        observationFormType={observationFormReference}
                        onSaved={_onSave}
                        onClose={closeModal}
                    />
                </ErrorBoundary >
            )}
             */